import {derived, writable} from 'svelte/store';
import {v4 as uuid4} from 'uuid';
import {sleep} from "../lib/sleep";
import _ from 'lodash';

export const snackbars = writable([]);

export const showSnackbar = async (message, {
  id,
  actions = [], // [{text, icon, action}, ...]
  duration = 1500} = {}) => {
  id = id || uuid4();

  if (_.some(actions, action => !action.text && !action.icon)) {
    throw new Error('text or icon is required');
  }

  snackbars.update(v => [...v, {
    id,
    props: {
      message, actions
    }
  }]);

  await sleep(duration);

  return await hideSnackbar(id);

};


export const hideSnackbar = async (id = null) => {
  snackbars.update(val => {
    if (!id) return _.tail(val);
    else return _.filter(val => v.id !== id);
  });
};